module.exports = __webpack_public_path__ + "static/img_01-db3e697c6b03e09fd3a35b6d1d05976f.png";